// This file exports the context-based subscription hook
// All subscription logic is centralized in SubscriptionContext to prevent
// duplicate RevenueCat initializations and concurrent request errors

import { useSubscriptionContext } from '@/contexts/SubscriptionContext';

/**
 * Hook to access subscription functionality.
 * Uses the centralized SubscriptionContext to avoid duplicate RevenueCat SDK initializations.
 *
 * @param campaignCountriesLanguagesId - Optional campaign ID (unused but kept for backward compatibility)
 * @returns Subscription state and functions
 */
export function useSubscription(campaignCountriesLanguagesId?: string | null) {
  return useSubscriptionContext();
}
